import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'; 
import config from '../../temp/config';
import axios from 'axios'; 
import { Formik, Field } from 'formik'
import * as Yup from 'yup';
import IconSVG from "../../utilities/FrontFunctions/IconSVG";
import ModalProduitConcernes from '../inc/Modal/ModalProduitConcernes';
import DefaultModal from '../inc/Modal/DefaultModal';
import MultipleFileUpload from '../inc/FormElements/MultipleFileUpload'
import { GetLogoList } from '../../utilities/FrontFunctions/AoxFrontFunctions'
import { megabytesToBytes } from '../../utilities/FrontFunctions/AoxFrontFunctions'

class ObjAsideChallengeADeclarer extends Component {
	constructor(props) {
		super(props)

		const participation = this.props.participation;
        const isChalengeVariable = participation?.Challenge?.Challenge_EvolutionPercent != null && participation?.Challenge?.Challenge_EvolutionPercent>0;
        const aucuneVenteFields = participation.Challenge.Conditions.map(condition => `Declarations_${condition.ChallengeCondition_Id}_AucuneVente`);

        let initialValues = {};
        let validationSchema = {};
        initialValues = {
            ...initialValues,
			ChallengeId: participation?.Challenge?.Challenge_Id,
            ...(participation.Challenge.Brand.Brand_Code !== "LDB" && { [`Declarations_Files`]: '' }),
        };
        validationSchema = {
            ...validationSchema,
			ChallengeId: Yup.number().required(),
            // Validation conditionnelle pour l'upload de fichier uploadés suivant la valeur de toutes les checkbox "Aucune vente"
            ...(participation.Challenge.Brand.Brand_Code !== "LDB" && {
                [`Declarations_Files`]: Yup.mixed()
                    .when(aucuneVenteFields, {
                        is: (...values) => values.every(value => value === true),
                        then: schema => schema.notRequired(),
                        otherwise: schema => schema.required()
                    })
            }),

            ...(participation.Challenge.Brand.Brand_Code !== "LDB" && isChalengeVariable && {
                [`Declarations_Files_2`]: Yup.mixed()
                    .when(aucuneVenteFields, {
                        is: (...values) => values.every(value => value === true),
                        then: schema => schema.notRequired(),
                        otherwise: schema => schema.required()
                    })
            }),
        };
        participation.Challenge.Conditions.forEach((condition, index) => {
            initialValues = {
                ...initialValues,
                [`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`]: false,
                [`Declarations_${condition.ChallengeCondition_Id}_Current`]: '',
                ...(isChalengeVariable && { [`Declarations_${condition.ChallengeCondition_Id}_Anterior`]: '' }),
                ...(participation.Challenge.Brand.Brand_Code === "LDB" && { [`Declarations_${condition.ChallengeCondition_Id}_Files`]: '' }),
                ...(participation.Challenge.Brand.Brand_Code === "LDB" && isChalengeVariable && { [`Declarations_${condition.ChallengeCondition_Id}_Files_2`]: '' }),
            };
            validationSchema = {
                ...validationSchema,
                [`Declarations_${condition.ChallengeCondition_Id}_Current`]: Yup.number().required(),
                ...(isChalengeVariable && { [`Declarations_${condition.ChallengeCondition_Id}_Anterior`]: Yup.number().required() }),
                // Validation conditionnelle pour les fichiers uploadés suivant la valeur de la checkbox "Aucune vente"
                ...(participation.Challenge.Brand.Brand_Code === "LDB" && {
                    [`Declarations_${condition.ChallengeCondition_Id}_Files`]: Yup.mixed()
                        .when(`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`, {
                            is: true,
                            then: schema => schema.notRequired(),
                            otherwise: schema => schema.required()
                        })
                }),
                ...(participation.Challenge.Brand.Brand_Code === "LDB" && isChalengeVariable && {
                    [`Declarations_${condition.ChallengeCondition_Id}_Files_2`]: Yup.mixed()
                        .when(`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`, {
                            is: true,
                            then: schema => schema.notRequired(),
                            otherwise: schema => schema.required()
                        })
                }),                
            };
        });
		this.state = {
			openMap: {},
			initialValues: initialValues,
			validationSchema: validationSchema,
		}
	}

	toggleAccordion = (key) => {
		this.setState(prev => ({
			openMap: {
				...prev.openMap,
				[key]: !prev.openMap[key]
			}
		}))
	}

	render() {
		const participation = this.props.participation
        const isChalengeVariable = participation?.Challenge?.Challenge_EvolutionPercent != null && participation?.Challenge?.Challenge_EvolutionPercent>0;

        return ( participation && 
            <div className="obj_saisie-vente">
                <div className="ctn_form">
                    <Formik
                        initialValues={this.state.initialValues}
                        validationSchema={Yup.object().shape(this.state.validationSchema)}
                        onSubmit={(values, actions) => {
                            document.body.classList.add('is-loading');

                            const formData = new FormData();
                            Object.entries(values).forEach(([key, value]) => {
                                // Les checkbox AucuneVente ne sont que pour la saisie, pas soumises
                                if (key.includes('_AucuneVente')) {
                                    return;
                                }

                                if (Array.isArray(value)) { 
                                    //multiupload => array File
                                    value.forEach(file => formData.append(key, file));
                                } else {
                                    formData.append(key, value);
                                }
                            });

                            axios.post(`${config.sitecoreApiHost}/apiaox/Challenge/PostChallengeDeclaration`, formData, {
                                withCredentials: true,
                                headers: { 'Content-Type': 'multipart/form-data' },
                            })
                            .then((result) => {
                                document.body.classList.remove('is-loading');
                                this.setState({
                                    formSubmitted: true,
                                    apiError : !result.data.IsValid,
                                    apiErrorMsg : result.data.ExceptionMessage,
                                });
                                if (result.data.IsValid) {
                                    this.modalDeclarationTransmise.openModal();
                                }
                            })
                            .catch((error) => {
                                document.body.classList.remove('is-loading');
                                this.setState({
									formSubmitted: true,
                                    apiError: true,
                                    apiErrorMsg: (error.response && error.response.status === 401) ? this.props.t('DefaultErrorConnexionMandatory') : this.props.t('DefaultServerError')
                                })
                                console.log(error.toJSON());
                            });
                        }}
                    >
                        {({ handleSubmit, setFieldValue, setFieldTouched, errors, touched, submitCount, values }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="obj_form">
                                    {participation.Challenge.Conditions.map((condition, index) => {
                                        const accordionKey = `id-${index}`
                                        const isOpen = !!this.state.openMap[accordionKey]
                                        const logo = GetLogoList().find(logo => logo.code === condition.Brand.Brand_Code);

                                        return (
                                            <div
                                                key={accordionKey}
                                                className={`obj_bloc_accordion-declaration-item${isOpen ? ' is-expanded' : ''}`}
                                            >
                                                <div className="obj_bloc_accordion-header">
                                                    <button
                                                        className="obj_bloc_accordion-button"
                                                        type="button"
                                                        onClick={() => this.toggleAccordion(accordionKey)}
                                                    >
                                                        <div className="obj_bloc_accordion-header-infos">
                                                            {participation.Challenge.Brand.Brand_Code === "LDB" && 
                                                                <div className="obj_bloc_accordion-header-logo">
                                                                    <img src={logo.image} alt={logo.label}/>
                                                                </div>
                                                            }
                                                            <h4 className="t_title">
                                                                {condition.ChallengeCondition_Name}
                                                                {condition.ChallengeCondition_EnableVariableGain && " ( condition variable )"}
                                                            </h4>
                                                        </div>
                                                        <div className="obj_bloc_accordion-icon"></div>
                                                    </button>
                                                </div>

                                                <div className="obj_bloc_accordion-container">
                                                    <div className="obj_bloc_accordion-content">
                                                        <div className="ctn_item">
                                                            <div className="ctn_title">
                                                                <h3 className="t_title">
                                                                    Saisir mes ventes
                                                                </h3>
                                                            </div>

                                                            <div className="ctn_checkbox">
                                                                <Field
                                                                    type="checkbox"
                                                                    id={`checkboxAucuneVente_${condition.ChallengeCondition_Id}`}
                                                                    name={`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`}
                                                                    //check => saisies à 0 et disable
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        setFieldValue(`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`,checked);
                                                                        if (checked) { 
                                                                            setFieldValue(`Declarations_${condition.ChallengeCondition_Id}_Current`,0);
                                                                            if (isChalengeVariable) {
                                                                                setFieldValue(`Declarations_${condition.ChallengeCondition_Id}_Anterior`,0);
                                                                            }
                                                                        }
                                                                    }}
                                                                />

                                                                <label
                                                                    htmlFor={`checkboxAucuneVente_${condition.ChallengeCondition_Id}`}
                                                                >
                                                                    Aucune vente
                                                                </label>
                                                            </div>

                                                            <button
                                                                className="obj_btn-popin-detail"
                                                                type="button"
                                                                onClick={() => this["ModalProduitCondition"+condition.ChallengeCondition_Id].openModal()}
                                                            >
                                                                <span>voir les produits concernés</span>
                                                                <IconSVG icon="arrowDown" />
                                                            </button>

                                                            <ModalProduitConcernes produits={condition.Produits} onRef={ref => (this["ModalProduitCondition"+condition.ChallengeCondition_Id] = ref)}/>

                                                            <div className="obj_saisie-vente-ctn_input">
                                                                <div className="ctn_row">
                                                                    <div className="ctn_input">
                                                                        <p className="t_label">{new Date(participation.Challenge.Challenge_EndDate).getFullYear()}*</p>
                                                                        <Field
                                                                            as="input"
                                                                            type="text"
                                                                            name={`Declarations_${condition.ChallengeCondition_Id}_Current`}
                                                                            placeholder="000"
                                                                            maxLength={6}
                                                                            disabled={values[`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`]}
                                                                            className={touched[`Declarations_${condition.ChallengeCondition_Id}_Current`] && errors[`Declarations_${condition.ChallengeCondition_Id}_Current`] && 'error'}
                                                                        />
                                                                    </div>
                                                                    {isChalengeVariable && (
                                                                        <div className="ctn_input">
                                                                            <p className="t_label">{new Date(participation.Challenge.Challenge_EndDate).getFullYear() - 1}*</p>
                                                                            <Field
                                                                                as="input"
                                                                                type="text"
                                                                                name={`Declarations_${condition.ChallengeCondition_Id}_Anterior`}
                                                                                placeholder="000"
                                                                                maxLength={6}
                                                                                disabled={values[`Declarations_${condition.ChallengeCondition_Id}_AucuneVente`]}
                                                                                className={touched[`Declarations_${condition.ChallengeCondition_Id}_Anterior`] && errors[`Declarations_${condition.ChallengeCondition_Id}_Anterior`] && 'error'}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* <!-- upload file par condition si LDB--> */}
                                                        {participation.Challenge.Brand.Brand_Code === "LDB" && <>
                                                            <div className="ctn_item">
                                                                <div className="ctn_title">
                                                                    {isChalengeVariable ?
                                                                        <h3 className="t_title">Importer mes listings {new Date(participation.Challenge.Challenge_EndDate).getFullYear()} *</h3>
                                                                    :
                                                                        <h3 className="t_title">Importer mes listings *</h3>
                                                                    }
                                                                    <button
                                                                        className="obj_icon-info"
                                                                        type="button"
                                                                        onClick={() => this.ModalInfoTexte?.openModal()}
                                                                    >
                                                                        <IconSVG icon="i_info" />
                                                                    </button>
                                                                </div>

                                                                <MultipleFileUpload
                                                                    fieldName={`Declarations_${condition.ChallengeCondition_Id}_Files`}
                                                                    setFieldValue={setFieldValue}
                                                                    setFieldTouched={setFieldTouched}
                                                                    errors={errors}
                                                                    touched={touched}
                                                                    labelText="Choisir un fichier"
                                                                    acceptedFormatsText="Formats acceptés : jpeg, png, pdf, excel, csv."
                                                                    maxSize={megabytesToBytes(10)}
                                                                    formatTypes={[
                                                                        'image/jpeg',
                                                                        'image/png',
                                                                        'application/pdf',
                                                                        'application/vnd.ms-excel', // .xls
                                                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                                                        'text/csv'
                                                                    ]}
                                                                    onUpload={() => console.log('Upload OK')}
                                                                    onUnload={() => console.log('Plus aucun fichier')}
                                                                />
                                                            </div>
                                                            {isChalengeVariable && 
                                                                <div className="ctn_item">
                                                                    <div className="ctn_title">
                                                                        <h3 className="t_title">Importer mes listings {new Date(participation.Challenge.Challenge_EndDate).getFullYear() - 1} *</h3>
                                                                        <button
                                                                            className="obj_icon-info"
                                                                            type="button"
                                                                            onClick={() => this.ModalInfoTexte?.openModal()}
                                                                        >
                                                                            <IconSVG icon="i_info" />
                                                                        </button>
                                                                    </div>

                                                                    <MultipleFileUpload
                                                                        fieldName={`Declarations_${condition.ChallengeCondition_Id}_Files_2`}
                                                                        setFieldValue={setFieldValue}
                                                                        setFieldTouched={setFieldTouched}
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        labelText="Choisir un fichier"
                                                                        acceptedFormatsText="Formats acceptés : jpeg, png, pdf, excel, csv."
                                                                        maxSize={megabytesToBytes(10)}
                                                                        formatTypes={[
                                                                            'image/jpeg',
                                                                            'image/png',
                                                                            'application/pdf',
                                                                            'application/vnd.ms-excel', // .xls
                                                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                                                            'text/csv'
                                                                        ]}
                                                                        onUpload={() => console.log('Upload OK')}
                                                                        onUnload={() => console.log('Plus aucun fichier')}
                                                                    />
                                                                </div>
                                                            }
                                                        </>}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                    {/* <!-- upload file unique si non LDB--></div> */}
                                    {participation.Challenge.Brand.Brand_Code !== "LDB" && <>
                                        <div
                                            key='id-files'
                                            className={`obj_bloc_accordion-declaration-item${!!this.state.openMap['id-files'] ? ' is-expanded' : ''}`}
                                        >
                                            <div className="obj_bloc_accordion-header">
                                                <button
                                                    className="obj_bloc_accordion-button"
                                                    type="button"
                                                    onClick={() => this.toggleAccordion('id-files')}
                                                >
                                                    <div className="obj_bloc_accordion-header-infos">
                                                        <h4 className="t_title">Importer mes fichiers {new Date(participation.Challenge.Challenge_EndDate).getFullYear()}</h4>
                                                    </div>
                                                    <div className="obj_bloc_accordion-icon"></div>
                                                </button>
                                            </div>

                                            <div className="obj_bloc_accordion-container">
                                                <div className="obj_bloc_accordion-content">
                                                    <div className="ctn_item">
                                                        <div className="ctn_title">
                                                            <h3 className="t_title">Importer mes listings *</h3>
                                                            <button
                                                                className="obj_icon-info"
                                                                type="button"
                                                                onClick={() => this.ModalInfoTexte?.openModal()}
                                                            >
                                                                <IconSVG icon="i_info" />
                                                            </button>
                                                        </div>

                                                        <MultipleFileUpload
                                                            fieldName="Declarations_Files"
                                                            setFieldValue={setFieldValue}
                                                            setFieldTouched={setFieldTouched}
                                                            errors={errors}
                                                            touched={touched}
                                                            labelText="Choisir un fichier"
                                                            acceptedFormatsText="Formats acceptés : jpeg, png, pdf, excel, csv."
                                                            maxSize={megabytesToBytes(10)}
                                                            formatTypes={[
                                                                'image/jpeg',
                                                                'image/png',
                                                                'application/pdf',
                                                                'application/vnd.ms-excel', // .xls
                                                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                                                'text/csv'
                                                            ]}
                                                            onUpload={() => console.log('Upload OK')}
                                                            onUnload={() => console.log('Plus aucun fichier')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {isChalengeVariable && 
                                            <div
                                                key='id-files_2'
                                                className={`obj_bloc_accordion-declaration-item${!!this.state.openMap['id-files_2'] ? ' is-expanded' : ''}`}
                                            >
                                                <div className="obj_bloc_accordion-header">
                                                    <button
                                                        className="obj_bloc_accordion-button"
                                                        type="button"
                                                        onClick={() => this.toggleAccordion('id-files_2')}
                                                    >
                                                        <div className="obj_bloc_accordion-header-infos">
                                                            <h4 className="t_title">Importer mes fichiers {new Date(participation.Challenge.Challenge_EndDate).getFullYear() - 1}</h4>
                                                        </div>
                                                        <div className="obj_bloc_accordion-icon"></div>
                                                    </button>
                                                </div>

                                                <div className="obj_bloc_accordion-container">
                                                    <div className="obj_bloc_accordion-content">
                                                        <div className="ctn_item">
                                                            <div className="ctn_title">
                                                                <h3 className="t_title">Importer mes listings *</h3>
                                                                <button
                                                                    className="obj_icon-info"
                                                                    type="button"
                                                                    onClick={() => this.ModalInfoTexte?.openModal()}
                                                                >
                                                                    <IconSVG icon="i_info" />
                                                                </button>
                                                            </div>

                                                            <MultipleFileUpload
                                                                fieldName="Declarations_Files_2"
                                                                setFieldValue={setFieldValue}
                                                                setFieldTouched={setFieldTouched}
                                                                errors={errors}
                                                                touched={touched}
                                                                labelText="Choisir un fichier"
                                                                acceptedFormatsText="Formats acceptés : jpeg, png, pdf, excel, csv."
                                                                maxSize={megabytesToBytes(10)}
                                                                formatTypes={[
                                                                    'image/jpeg',
                                                                    'image/png',
                                                                    'application/pdf',
                                                                    'application/vnd.ms-excel', // .xls
                                                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                                                    'text/csv'
                                                                ]}
                                                                onUpload={() => console.log('Upload OK')}
                                                                onUnload={() => console.log('Plus aucun fichier')}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </>}

                                    <DefaultModal 
                                        onRef={ref => (this.ModalInfoTexte = ref)}
                                        htmlContent={
                                            <>
                                                <p className="t_title">Importer mes listings *</p>
                                                <p className="t_main">
                                                    Si votre challenge concerne une évolution sur deux années différentes, vous devrez nous transmettre les fichiers de ventes de référence sur cette période.<br/>
                                                    Attention : sans l'intégralité de ces fichiers, votre déclaration sera refusée et vous devrez déclarer à nouveau votre challenge.                                                    
                                                </p>
                                                <div className="ctn_cta">
                                                    <button className="obj_cta" type="button" onClick={() => this.ModalInfoTexte.closeModal()}>fermer</button>
                                                </div>
                                            </>
                                        }
                                    />

                                    <p className="t_mention mb_30">Informations obligatoires *</p>

                                    <div className="ctn_cta">
                                        <button className="obj_cta" type="submit">
                                            Envoyer
                                        </button>
                                    </div>

                                    {!this.state.formSubmitted && submitCount > 0 && (
                                        <p className="t_error mb_30">Le formulaire est incomplet</p>
                                    )}

                                    {this.state.apiError && (
                                        <p className="t_error mb_30 fade-in">{this.state.apiErrorMsg}</p>
                                    )}
                                </div>
                            </form>
                        )}
                    </Formik>

                    <DefaultModal
                        onRef={(ref) => (this.modalDeclarationTransmise = ref)}
                        onClose={() => window.location.reload(false)}
                        htmlContent={
                            <>
                                <p className="t_title">Votre déclaration a bien été transmise.</p>
                                <p className="t_main"></p>
                                <div className="ctn_cta">
                                    <button className="obj_cta" type="button" onClick={() => window.location.reload(false)}>fermer</button>
                                </div>
                            </>
                        }
                    />
                </div>
            </div>
        )
    }
}

export default withTranslation()(ObjAsideChallengeADeclarer);
